import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateRUConfiguration } from '@api/ruConfigurations';

import { IUpdateRUConfigurationsDTO } from '@interfaces/cmModule/dto/ruConfigurationsDTO';
import { IPartialOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { RU_CONFIGURATION_UPDATE, RU_CONFIGURATIONS  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateUpdateRUConfigurationReturned {
	updateRUConfiguration: UseMutateFunction<void, unknown, IUpdateRUConfigurationsDTO, unknown>;
	isLoadingUpdateRUConfiguration: boolean;
}

export const useMutateUpdateRUConfiguration = ({
	onSuccess,
}: IPartialOnSuccess): IUseMutateUpdateRUConfigurationReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IUpdateRUConfigurationsDTO>({
		mutationKey: [RU_CONFIGURATION_UPDATE],
		mutationFn: updateRUConfiguration,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateRUConfiguration,
				type: ESnackbarTypes.success,
			}));

			onSuccess?.();

			return [queryClient.invalidateQueries([RU_CONFIGURATIONS])];
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		updateRUConfiguration: mutate,
		isLoadingUpdateRUConfiguration: isLoading,
	};
};
